var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.value.isReportGroupLoading ? _c('v-card', [_c('v-skeleton-loader', {
    attrs: {
      "type": "card-heading, divider, list-item-two-line, list-item-two-line, list-item-two-line"
    }
  })], 1) : _c('v-card', {
    key: 'value.group.id' + (_vm.value.group ? _vm.value.group.id : ''),
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("report.reportGroup")) + " "), _c('v-spacer'), _vm.canUpdateReport ? _c('span', [!_vm.value.groupId && _vm.canReadReportGroup ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "loading": _vm.isEditGroupDialogLoading,
      "icon": "mdi-plus"
    },
    on: {
      "click": _vm.startEditGroupDialog
    }
  }) : _vm.canReadReportGroup ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-pencil",
      "loading": _vm.isEditGroupDialogLoading
    },
    on: {
      "click": _vm.startEditGroupDialog
    }
  }) : _vm._e()], 1) : _vm._e()], 1), !_vm.value.groupId ? _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-bookshelf",
      "text": "Keine Gruppe hinterlegt."
    }
  })], 1) : !_vm.value.group ? _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-bookshelf",
      "text": "Gruppe nicht gefunden."
    }
  })], 1) : _c('v-card-text', [_c('v-sheet', {
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('refs-report-group', {
    attrs: {
      "item": _vm.value.group
    },
    on: {
      "openDetail": function openDetail() {
        return _vm.value.group.goTo(_vm.$router).customView();
      }
    }
  })], 1), _vm.value.group.configuration && _vm.value.group.configuration.customFieldConfig && _vm.value.group.configuration.customFieldConfig.length ? _c('div', [_vm.isLoadingCustomFieldValues ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _c('v-divider'), _c('custom-field-list-form', {
    staticClass: "mt-6",
    attrs: {
      "customFieldConfig": _vm.value.group.configuration.customFieldConfig
    },
    on: {
      "change": _vm.debounceSaveCustomFields
    },
    model: {
      value: _vm.customFieldValues,
      callback: function callback($$v) {
        _vm.customFieldValues = $$v;
      },
      expression: "customFieldValues"
    }
  })], 1) : _vm._e()], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isEditGroupDialogActive,
      "title": _vm.$t('report.editReportGroup')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isEditGroupDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isEditGroupDialogActive = $event;
      },
      "leftClick": _vm.close,
      "rightClick": _vm.saveGroup
    }
  }, [_c('v-select', {
    key: 'v-select-' + (_vm.groupCopy ? _vm.groupCopy.id : ''),
    staticClass: "mt-2",
    attrs: {
      "value": _vm.groupCopy ? _vm.groupCopy.id : '',
      "item-value": "id",
      "items": _vm.groups,
      "label": _vm.$t('objects.report.groupId'),
      "outlined": "",
      "loading": _vm.isLoadingReportGroup
    },
    on: {
      "change": _vm.handleGroupChange
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('refs-report-group', {
          attrs: {
            "item": item
          }
        })];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('refs-report-group', {
          attrs: {
            "item": item
          }
        })];
      }
    }])
  }), _c('div', {
    staticClass: "mt-n7",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "elevation": 0,
      "loading": _vm.isLoadingReportGroups
    },
    on: {
      "click": _vm.refreshReportGroups
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.refresh")) + " ")]), _c('report-group-create-dialog', {
    attrs: {
      "partnerId": _vm.value.partnerId
    },
    on: {
      "created": function created(group) {
        return _vm.value.groupId = group.id;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on;
        return [_c('v-btn', {
          staticClass: "mt-n1",
          attrs: {
            "x-small": "",
            "text": "",
            "elevation": 0
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return on.apply(null, arguments);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")])];
      }
    }])
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }